module.exports = __webpack_public_path__ + "media/styles/images/svg/pip-teal-ce0024abe9d8682bb9aa8a154f871a77.svg";